import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

const PLACEHOLDER_SRC =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='50'%3E%3Crect fill='%23e8e8e8' width='80' height='50'/%3E%3C/svg%3E";

@Directive({
  selector: 'img[appLazyImage]'
})
export class LazyImageDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input('appLazyImage') imageSrc = '';

  private observer: IntersectionObserver | null = null;
  private hasLoaded = false;

  constructor(private elementRef: ElementRef<HTMLImageElement>) {}

  ngAfterViewInit(): void {
    const img = this.elementRef.nativeElement;
    img.decoding = 'async';
    img.loading = 'lazy';
    if (!img.src) {
      img.src = PLACEHOLDER_SRC;
    }
    this.observe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['imageSrc']) {
      return;
    }
    if (this.hasLoaded) {
      this.applySrc();
      return;
    }
    if (this.observer) {
      this.observer.unobserve(this.elementRef.nativeElement);
      this.observe();
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }

  private observe(): void {
    const img = this.elementRef.nativeElement;
    if (!this.imageSrc) {
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.applySrc();
      return;
    }

    const root = img.closest('.preview-table-container') as HTMLElement | null;
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.applySrc();
            this.observer?.unobserve(img);
          }
        }
      },
      { root, rootMargin: '200px 0px', threshold: 0.01 }
    );
    this.observer.observe(img);
  }

  private applySrc(): void {
    if (!this.imageSrc) {
      return;
    }
    const img = this.elementRef.nativeElement;
    if (img.src !== this.imageSrc) {
      img.src = this.imageSrc;
    }
    this.hasLoaded = true;
  }
}
